module.exports = __webpack_public_path__ + "static/media/ovalArrow.ce4fa5c3.svg";